import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Application } from '@modules/common/types/application';
import { Next7Days } from '@modules/common/types/next-7-days';
import { priorities } from '@modules/form-controls/types/priorities';
import { AdvancedSearchService } from '@modules/search/services/advanced-search.service';
import { VirtualFolder } from '@modules/tasks/types/virtual-folder';
import { addDays } from '@sharedlib/common/utils/date';

@Component({
  selector: 'app-tasks-list-context-menu',
  templateUrl: './tasks-context-menu.component.html',
  styleUrls: ['./tasks-context-menu.component.less'],
  standalone: false,
})
export class TasksContextMenuComponent {
  // Input
  @Input() filterKey: VirtualFolder;

  // Outputs
  @Output() change = new EventEmitter<VirtualFolder>();

  // Public
  public nextWeekDays: { name: Next7Days; date: Date }[];
  public prioritiesList = priorities;

  protected readonly searchService = inject(AdvancedSearchService);
  protected readonly isAdvancedSearchApplied = toSignal(
    this.searchService.isAdvancedSearchApplied(Application.tasking),
    {
      initialValue: false,
    },
  );

  /**
   * Constructor
   */

  constructor() {
    const today = new Date();
    this.nextWeekDays = Array.from({ length: 7 }, (_v, k) => ({
      name: ('day' + k) as Next7Days,
      date: addDays(today, k + 1),
    }));
  }

  /**
   * Actions
   */

  selectFilter(filter: VirtualFolder) {
    this.change.emit(filter);
  }
}
